// setTimeout(() => {
//   const orderSampleMail = document.querySelector(".cus_email_open_btn");
//   const cusGmail = document.querySelector(".custom-popup-overlay");
//   const productTitle =
//     document.querySelector(
//       ".product__block.product__block--title .product__title"
//     )?.innerText || "";

//   if (orderSampleMail && cusGmail) {
//     orderSampleMail.addEventListener("click", function (e) {
//       e.preventDefault();

//       const email = cusGmail.getAttribute("data-mail") || "";
//       const emailSub = cusGmail.getAttribute("data-sample-mail-sub") || "";
//       const emailMsg = cusGmail.getAttribute("data-sample-mail-mssg") || "";

//       const subject = `${emailSub} - ${productTitle}`;

//       const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
//         email
//       )}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(
//         emailMsg
//       )}`;

//       window.open(gmailLink, "_blank");
//     });
//   }
// }, 1200);

document.addEventListener("DOMContentLoaded", () => {
  const checkInterval = setInterval(() => {
    const orderSampleMail = document.querySelector(".cus_email_open_btn");
    const cusGmail = document.querySelector(".custom-popup-overlay");
    const productTitle =
      document.querySelector(
        ".product__block.product__block--title .product__title"
      )?.innerText || "";

    if (orderSampleMail && cusGmail) {
      clearInterval(checkInterval); // Stop checking

      orderSampleMail.addEventListener("click", function (e) {
        e.preventDefault();
        // console.log(e, "Email request triggered");

        const email = cusGmail.getAttribute("data-mail") || "";
        const emailSub = cusGmail.getAttribute("data-sample-mail-sub") || "";
        const emailMsg = cusGmail.getAttribute("data-sample-mail-mssg") || "";

        const subject = `${emailSub} - ${productTitle}`;

        const mailtoLink = `mailto:${encodeURIComponent(
          email
        )}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
          emailMsg
        )}`;

        window.location.href = mailtoLink;
      });
    }
  }, 300); 
});

const optCheckbox = document.querySelector(".opt-product-toggle");
const optionalProductBlock = document.querySelector(".optional-product-block");
const variantId = optionalProductBlock?.getAttribute("data-prd-id");
const atc = document.querySelector(".product-form__submit");
const OPTIONAL_ADDED_FLAG = "optionalAdded";

if (optCheckbox && variantId) {
  optCheckbox.addEventListener("change", async function () {
    const api = optCheckbox.checked ? "cart/add.js" : "cart/change.js";
    // if (optCheckbox.checked) {
    let formData;
    try {
      if (optCheckbox.checked) {
        formData = {
          items: [{ id: variantId, quantity: 1 }],
        };
      } else {
        formData = {
          id: variantId,
          quantity: 0,
        };
      }

      const response = await fetch(window.Shopify.routes.root + api, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!response.ok) throw new Error("Failed to add optional product");

      await response.json();
      // console.log("added to local str");

      localStorage.setItem(OPTIONAL_ADDED_FLAG, "true");
    } catch (error) {}
    // }
  });
}

if (atc) {
  atc.addEventListener("click", function () {
    localStorage.removeItem(OPTIONAL_ADDED_FLAG);
    if (optCheckbox) optCheckbox.checked = false;
    setTimeout(() => {
      document.querySelector(".cart-drawer-button").click();
    }, 1000);
  });
}

window.addEventListener("DOMContentLoaded", async () => {
  const shouldRemove = localStorage.getItem(OPTIONAL_ADDED_FLAG);

  if (shouldRemove && variantId) {
    try {
      const cartRes = await fetch(window.Shopify.routes.root + "cart.js");
      const cart = await cartRes.json();

      const optionalItem = cart.items.find((item) => item.id == variantId);
      if (optionalItem) {
        const newQty =
          optionalItem.quantity > 1 ? optionalItem.quantity - 1 : 0;

        await fetch(window.Shopify.routes.root + "cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: optionalItem.key,
            quantity: newQty,
          }),
        });

        // $(".drawer__inner").load(location.href + " #CartDrawer > *");
        $("#CartDrawer").load(location.href + " #CartDrawer > *");
        $(".cart-drawer-button").load(location.href + " .cart-drawer-button");
      }
    } catch (error) {}
    localStorage.removeItem(OPTIONAL_ADDED_FLAG);
  }
});

const cusCart = document.querySelector("#CartDrawer");

document.addEventListener("click", (e) => {
  if (
    e.target.closest(".drawer__close-btn") ||
    e.target.closest(".fixed-overlay")
  ) {
    if (cusCart && cusCart.hasAttribute("open")) {
      cusCart.removeAttribute("open");
    }
  }
});
